/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 16oTSa7DQBPEWCKQEY9DXA
// Component: BEFtbqk04VMi

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { BaseSliderThumb } from "@plasmicpkgs/react-aria/skinny/registerSliderThumb";
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: 16oTSa7DQBPEWCKQEY9DXA/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 16oTSa7DQBPEWCKQEY9DXA/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicSliderThumb.module.css"; // plasmic-import: BEFtbqk04VMi/css

createPlasmicElementProxy;

export type PlasmicSliderThumb__VariantMembers = {};
export type PlasmicSliderThumb__VariantsArgs = {};
type VariantPropType = keyof PlasmicSliderThumb__VariantsArgs;
export const PlasmicSliderThumb__VariantProps = new Array<VariantPropType>();

export type PlasmicSliderThumb__ArgsType = {
  disabled?: boolean;
  autoFocus?: boolean;
};
type ArgPropType = keyof PlasmicSliderThumb__ArgsType;
export const PlasmicSliderThumb__ArgProps = new Array<ArgPropType>(
  "disabled",
  "autoFocus"
);

export type PlasmicSliderThumb__OverridesType = {
  root?: Flex__<typeof BaseSliderThumb>;
};

export interface DefaultSliderThumbProps {
  disabled?: boolean;
  autoFocus?: boolean;
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicSliderThumb__RenderFunc(props: {
  variants: PlasmicSliderThumb__VariantsArgs;
  args: PlasmicSliderThumb__ArgsType;
  overrides: PlasmicSliderThumb__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  const [$ccVariants, setDollarCcVariants] = React.useState<
    Record<string, boolean>
  >({
    dragging: false,
    hovered: false,
    focused: false,
    focusVisible: false,
    disabled: false
  });
  const updateVariant = React.useCallback(
    (changes: Record<string, boolean>) => {
      setDollarCcVariants(prev => {
        if (!Object.keys(changes).some(k => prev[k] !== changes[k])) {
          return prev;
        }
        return { ...prev, ...changes };
      });
    },
    []
  );

  return (
    <BaseSliderThumb
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      advanced={false}
      autoFocus={args.autoFocus}
      children={null}
      className={classNames(
        "__wab_instance",
        "root_reset_16oTSa7DQBPEWCKQEY9DXA",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
      isDisabled={args.disabled}
      plasmicUpdateVariant={updateVariant}
    />
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: typeof BaseSliderThumb;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicSliderThumb__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicSliderThumb__VariantsArgs;
    args?: PlasmicSliderThumb__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicSliderThumb__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicSliderThumb__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSliderThumb__ArgProps,
          internalVariantPropNames: PlasmicSliderThumb__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSliderThumb__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSliderThumb";
  } else {
    func.displayName = `PlasmicSliderThumb.${nodeName}`;
  }
  return func;
}

export const PlasmicSliderThumb = Object.assign(
  // Top-level PlasmicSliderThumb renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicSliderThumb
    internalVariantProps: PlasmicSliderThumb__VariantProps,
    internalArgProps: PlasmicSliderThumb__ArgProps
  }
);

export default PlasmicSliderThumb;
/* prettier-ignore-end */
